import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import { CustomPaper } from "../../../resume-intelligence/Style";
import {
  StyledFlexColumnView,
  StyledFlexRowView,
} from "../../../common-components/StyledComponents";
import BoxEditIco from "../../../../assets/icons/BoxEditIco";
import DeleteIco from "../../../../assets/icons/DeleteIco";
import { StyledSpaceBetweenBox } from "../../../matches/quick-match/components/StyledComponent";
import PolymathIco from "../../../../assets/images/polymath.png";
import SpheruleIco from "../../../../assets/images/spherule.png";
import LightboxIco from "../../../../assets/images/lightbox.png";
import CommonTextField from "../../../../component/Input";

function IgniteSummary() {
  const [open, setOpen] = useState(false);
  const [sections, setSections] = useState([
    {
      id: 1,
      icon: PolymathIco,
      title: "Company Overview",
      text: "Company Name: State of Minnesota Department of Employment and Economic Development (DEED)",
      subText:
        "Mission: Provide economic development and employment services to enhance the quality of life in Minnesota.",
      content:
        "Vision: To create an equitable and thriving economy through innovation and collaboration.",
    },
    {
      id: 2,
      icon: SpheruleIco,
      title: "Business Outcome Desired",
      text: "Project Title: Salesforce Implementation and Management",
      subText:
        "Objective: To leverage the Salesforce platform for developing SaaS applications that enhance operational efficiency and service delivery in various departments.",
      content: "Duration: 12-24 months (depending on project scope)",
    },
    {
      id: 3,
      icon: LightboxIco,
      title: "Key Stakeholder",
      text: "The project team will report directly to Charles McKensie.",
      subText: "",
      content: "",
    },
  ]);

  const [editText, setEditText] = useState({
    id: null,
    text: "",
    subText: "",
    content: "",
  });

  // const handleOpen = (section) => {
  //   setEditText(section);
  //   setOpen(true);
  // };

  const labelMapping = {
    "Company Overview": {
      text: "Company Name",
      subText: "Mission",
      content: "Vision",
    },
    "Business Outcome Desired": {
      text: "Project Title",
      subText: "Objective",
      content: "Duration",
    },
    "Key Stakeholder": {
      text: "Stakeholder",
      subText: "Role",
      content: "Details",
    },
  };

  const handleOpen = (section) => {
    setEditText({
      id: section.id,
      text: section.text,
      subText: section.subText,
      content: section.content,
      labels: labelMapping[section.title] || {
        text: "Text",
        subText: "Sub Text",
        content: "Content",
      },
    });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    setSections((prevSections) =>
      prevSections.map((section) =>
        section.id === editText.id ? { ...section, ...editText } : section
      )
    );
    setOpen(false);
  };

  const renderSection = (section) => (
    <CustomPaper
      key={section.id}
      variant="outlined"
      width="100%"
      padding={"12px"}
      marginBottom={"10px"}
      display={"flex"}
      alignItems={"start"}
    >
      <StyledSpaceBetweenBox
        sx={{
          alignItems: "flex-start",
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <StyledFlexRowView style={{ alignItems: "flex-start" }}>
          <img
            src={section.icon}
            style={{ width: "48px", height: "48px" }}
            alt="logo"
          />
          <StyledFlexColumnView style={{ gap: "13px" }}>
            <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
              {section.title}
            </Typography>
            <Typography
              sx={{ color: "#475467", fontWeight: 500, fontSize: "16px" }}
            >
              {section.text}
            </Typography>
            {section.subText && (
              <Typography
                sx={{ color: "#475467", fontWeight: 500, fontSize: "16px" }}
              >
                {section.subText}
              </Typography>
            )}
            {section.content && (
              <Typography
                sx={{ color: "#475467", fontWeight: 500, fontSize: "16px" }}
              >
                {section.content}
              </Typography>
            )}
          </StyledFlexColumnView>
        </StyledFlexRowView>

        <StyledFlexRowView gap={"20px"}>
          <IconButton
            size="small"
            sx={{
              border: "1px solid #D0D5DD",
              borderRadius: "8px",
              padding: "8px",
            }}
            onClick={() => handleOpen(section)}
          >
            <BoxEditIco />
          </IconButton>
          <IconButton
            size="small"
            sx={{
              border: "1px solid #D0D5DD",
              borderRadius: "8px",
              padding: "8px",
            }}
          >
            <DeleteIco />
          </IconButton>
        </StyledFlexRowView>
      </StyledSpaceBetweenBox>
    </CustomPaper>
  );

  return (
    <>
      {sections.map(renderSection)}

      {/* Edit Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        sx={{ borderRadius: "16px" }}
      >
        <DialogTitle sx={{ fontSize: "20px", fontWeight: 700 }}>
          Edit Summary
        </DialogTitle>
        <DialogContent sx={{ marginTop: "20px", overflowY: "unset" }}>
          <StyledFlexColumnView style={{ gap: "20px" }}>
            <CommonTextField
              fullWidth
              multiline
              // label="Text"
              label={editText.labels?.text || ""}
              value={editText.text}
              onChange={(e) =>
                setEditText({ ...editText, text: e.target.value })
              }
              sx={{ marginTop: 2 }}
            />
            <CommonTextField
              fullWidth
              multiline
              // label="Sub Text"
              label={editText.labels?.subText || ""}
              value={editText.subText}
              onChange={(e) =>
                setEditText({ ...editText, subText: e.target.value })
              }
              sx={{ marginTop: 2 }}
            />
            <CommonTextField
              fullWidth
              multiline
              // label="Content"
              label={editText.labels?.content || ""}
              value={editText.content}
              onChange={(e) =>
                setEditText({ ...editText, content: e.target.value })
              }
              sx={{ marginTop: 2 }}
            />
          </StyledFlexColumnView>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSave} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default IgniteSummary;
